import { render, staticRenderFns } from "./Spinner.vue?vue&type=template&id=24b77565&lang=pug&"
import script from "./Spinner.vue?vue&type=script&lang=js&"
export * from "./Spinner.vue?vue&type=script&lang=js&"
import style0 from "./Spinner.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b77565')) {
      api.createRecord('24b77565', component.options)
    } else {
      api.reload('24b77565', component.options)
    }
    module.hot.accept("./Spinner.vue?vue&type=template&id=24b77565&lang=pug&", function () {
      api.rerender('24b77565', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/Spinner.vue"
export default component.exports